import React from 'react';
import { AppBar, Box, Toolbar, Typography, useTheme } from '@mui/material';
import ftaLogo from '../../../assets/logo/logo-fta.webp';
import uaeLogo from '../../../assets/logo/logo-UAE-new.webp';
import appConfig from '../../../config/appConfig';

function OnboardingHeader() {
  const theme = useTheme();

  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: theme.palette.common.white,
        boxShadow: theme.shadows[3],
      }}
    >
      <Toolbar>
        <img src={appConfig.brandLogoPath} height="35" alt="Logo" style={{ marginRight: theme.spacing(2) }} />
        <Typography
          variant="h5"
          noWrap
          component="div"
          color="black"
          sx={{ fontWeight: theme.typography.fontWeightBold }}
        ></Typography>
        <Box sx={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
          <img src={ftaLogo} height="40" alt="Logo" style={{ marginRight: theme.spacing(2) }} />
          <img src={uaeLogo} height="50" alt="Logo" style={{ marginRight: theme.spacing(2) }} />
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default OnboardingHeader;
